











































































import ValidateInput from '@/components/common/input/ValidateInput.vue';
import ItemTable from '@/components/common/ItemTable.vue';
import TuiGrid from 'tui-grid';

import {Vue, Component} from 'vue-property-decorator';
import {RadioRenderer} from '@/utils/commonUtils';
import {i18nInObjectList} from '@/utils/i18n';
@Component({
  components: {ValidateInput, ItemTable}
})
export default class PartnerPool extends Vue {
  private pageType = 'contract';
  private initOver = false;
  // 회사명
  private companyName = '';
  private companyNameErrFlg = '';
  private companyNameOptions = {
    name: 'companyName',
    type: 'company-name'
  };

  // 사업자등록번호
  private registrationNo = '';
  private registrationNoErrFlg = '';
  private registrationNoOptions = {
    name: 'registrationNo',
    type: 'text-num'
  };

  // 조회
  private async search() {
    if (this.companyName.length === 0) {
      alert(this.$t('PARTNER_POOL_ERR_COMPANY_NAME_NULL'));
      (this.$refs.companyName as any).focus();
      return;
    }
    if (this.registrationNo.length === 0) {
      alert(this.$t('PARTNER_POOL_ERR_REGISTRATION_NO_NULL'));
      (this.$refs.companyName as any).focus();
      return;
    }

    let request = {
      params: {
        companyName: this.companyName,
        registrationNo: this.registrationNo
      }
    };

    let {data} = await this.$api.getPartnersActive(request);
    this.partners = data.contents;
    this.totalCount = data.totalCount;
  }

  // 조회결과
  private partners: any = [];
  private totalCount = 0;
  private gridOptions = {
    name: 'partner_list',
    haveRigthBtn: false,
    onLoadSearch: false,
    nonDataBodyHeight: 35,
    haveDataBodyHeight: 155
  };
  private gridProps = {
    header: {
      height: 33
    },
    options: {
      rowHeaders: [
        {
          name: 'radioBtn',
          type: 'radio',
          header: 'COMMON_SELECT',
          renderer: RadioRenderer
        }
      ],
      copyOptions: {
        useFormattedValue: true
      },
      bodyHeight: 155,
      minRowHeight: 35,
      displayRowCount: 10,
      keyColumnName: 'partnerNo',
      columnOptions: {
        resizable: true
      }
    },
    columns: [
      {
        header: 'PARTNER_POOL_HEADER_PARTNER_NO',
        name: 'partnerNo',
        align: 'center',
        minWidth: 60
      },
      {
        header: 'PARTNER_POOL_HEADER_PARTNER_NAME',
        name: 'partnerName',
        align: 'center',
        minWidth: 200
      },
      {
        header: 'PARTNER_POOL_HEADER_COMPANY_NAME',
        name: 'companyName',
        align: 'center',
        minWidth: 140
      },
      {
        header: 'PARTNER_POOL_HEADER_REGISTRATION_NO',
        name: 'businessRegistrationNo',
        align: 'center',
        minWidth: 140,
        formatter: function(cell: any) {
          let registrationNo = cell.row.business.registrationNo;
          if (registrationNo !== null && registrationNo.length > 6) {
            return `${registrationNo.substring(0, 3)}-${registrationNo.substring(3, 5)}-${registrationNo.substring(5)}`;
          } else {
            return registrationNo;
          }
        }
      },
      {
        header: 'PARTNER_POOL_HEADER_DECLARATION_NO',
        name: 'onlineMarketingBusinessDeclarationNo',
        align: 'center',
        minWidth: 180,
        formatter: function(cell: any) {
          return cell.row.business.onlineMarketingDeclarationNo;
        }
      },
      {
        header: 'PARTNER_POOL_HEADER_PHONE_NO',
        name: 'representPhoneNo',
        align: 'center',
        minWidth: 120,
        formatter: function(cell: any) {
          return cell.row.representative.phoneNo;
        }
      },
      {
        header: 'PARTNER_POOL_HEADER_EMAIL',
        name: 'representEmail',
        align: 'center',
        minWidth: 200,
        formatter: function(cell: any) {
          return cell.row.representative.email;
        }
      }
    ]
  };

  // 다음
  private next() {
    let checkedRows = (this.$refs.itemTable as any).gridFunction('getCheckedRows');
    let partnerNo = checkedRows && checkedRows.length > 0 ? checkedRows[0].partnerNo : 0;
    if (partnerNo === 0) {
      alert(this.$t('PARTNER_POOL_ERR_NOT_SELECT'));
      return;
    }
    sessionStorage.setItem('poolCompanyName', this.companyName);
    sessionStorage.setItem('poolRegistrationNo', this.registrationNo);
    if (this.pageType === 'contract') {
      this.$router.push(`/partner/contract-prev?partnerNo=${partnerNo}`);
    } else {
      this.$router.push(`/partner/copy-prev?partnerNo=${partnerNo}`);
    }
  }

  private async created() {
    let defaultName = sessionStorage.getItem('poolCompanyName');
    if (defaultName) {
      this.companyName = defaultName;
      sessionStorage.removeItem('poolCompanyName');
    }
    let defaultNo = sessionStorage.getItem('poolRegistrationNo');
    if (defaultNo) {
      this.registrationNo = defaultNo;
      sessionStorage.removeItem('poolRegistrationNo');
    }
    if (this.$route.name === 'PartnerPoolContract') {
      this.pageType = 'contract';
    } else {
      this.pageType = 'copy';
    }
    let noData = this.$t('PARTNER_POOL_TABLE_NO_DATA') as string;
    TuiGrid.setLanguage('ko', {
      display: {
        noData
      }
    });
    this.gridProps = i18nInObjectList(this, this.gridProps, 'columns', 'header');
    this.gridProps.options.rowHeaders[0].header = this.$t(this.gridProps.options.rowHeaders[0].header) as string;
    this.initOver = true;
  }

  private beforeRouteEnter(to, from, next) {
    if (from.name !== 'PartnerContractPrev' && from.name !== 'PartnerCopyPrev') {
      sessionStorage.removeItem('poolCompanyName');
      sessionStorage.removeItem('poolRegistrationNo');
    }
    next();
  }

  private beforeDestroy(): void {
    let noData = this.$t('COMMON_RESULT_NONE') as string;
    TuiGrid.setLanguage('ko', {
      display: {
        noData
      }
    });
  }
}
